import { render, staticRenderFns } from "./CreateMultiBoxDropDown.vue?vue&type=template&id=473e10ea&scoped=true"
import script from "./CreateMultiBoxDropDown.vue?vue&type=script&lang=js"
export * from "./CreateMultiBoxDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473e10ea",
  null
  
)

export default component.exports